// P96 — CP Marketing → Newsletters' requests (super admin only, the session's cookie): a list's subscribers (accounts
// and the site box's guests), its counters, the CSV of its subscribed rows, and the two actions on a guest. Each 4xx
// keeps the API's own code (`newsletterLabels.errorText`).
import { get, post } from "helpers/api_helper"

const config = { timeout: 20000 }
export const query = params => new URLSearchParams(Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "" && value !== "all")).toString()
const data = response => {
  if (!response || typeof response.data !== "object" || response.data === null) throw new Error("Invalid Newsletters response")
  return response.data
}

export const getSubscribers = filters => get(`/admin/marketing/newsletter-subscribers?${query(filters)}`, config).then(data)
export const getSummary = list => get(`/admin/marketing/newsletter-subscribers/summary?${query({ list })}`, config).then(data)
export const unsubscribeGuest = id => post(`/admin/marketing/newsletter-guests/${encodeURIComponent(id)}/unsubscribe`, {}, config).then(data)
export const deleteGuest = id => post(`/admin/marketing/newsletter-guests/${encodeURIComponent(id)}/delete`, {}, config).then(data)
// The whole filter's subscribed rows, as the CSV the gateway writes (and logs)
export const getExport = filters => get(`/exports/newsletter-subscribers?${query({ ...filters, page: undefined, limit: undefined, status: undefined })}`,
  { responseType: "arraybuffer", timeout: 180000 })
